import StartpageView from './ContentViews/StartPageView';
import ListingView from './ContentViews/ListingView';
import DocumentView from './ContentViews/DocumentView';
import FullView from './ContentViews/FullView';
import PanoramaTeaserView from './ContentViews/PanoramaTeaserView';

const ContentTypeSwitch = ({children, ...props}) => {
    let elem = [];

    if(props.item["@type"] === "Plone Site") {
        elem.push(<StartpageView/>);
    }

    if(props.item["index_page"]) {
        elem.push(<ContentTypeSwitch item={ props.item["index_page"] }/>);
    }

    if(props.item["@type"] === "Plone Site" || props.item["index_page"]) {
        return <div>{ elem }</div>;
    }

    if (typeof props.item !== "object" || !props.item.hasOwnProperty("layout")) {
        return elem;
    }

    if (["view", "document_view"].indexOf(props.item["layout"]) >= 0) {
        switch (props.item["@type"]) {
            case "panorama-point":
                elem = (
                    <div>
                        <DocumentView item={props.item}/>
                        <FullView item={props.item} hideSelf={true}/>
                    </div>
                );
                break;
            case "panorama-teaser":
                elem = <PanoramaTeaserView item={props.item} titleH2={true}/>
                break;
            case "lkd-document":
                elem = (
                    <div>
                        <DocumentView item={props.item}/>
                        {props.item.items.length && <h2>Inhalte:</h2> || null}
                        <ListingView item={props.item} hideSelf={true}/>
                    </div>
                );
                break;
            case "Document":
            default:
                elem = <DocumentView item={props.item}/>;
                break;
        }
    } else {
        switch (props.item["layout"]) {
            case "full_view":
                elem = <FullView item={props.item}/>;
                break;
            default:
                elem = <ListingView item={props.item}/>;
                break;
        }
    }

    return elem;
};

export default ContentTypeSwitch;


// WEBPACK FOOTER //
// ./components/ContentTypeSwitch.jsx